module.exports = global["MobileDetect"] = require("-!./mobile-detect.js");


//////////////////
// WEBPACK FOOTER
// ./~/mobile-detect/mobile-detect.js
// module id = 554
// module chunks = 0